module.exports = __webpack_public_path__ + "static/media/gupta_Qa6ihOVEaN.9a33ac0b.jpg";